import styled, { css } from 'styled-components'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import { brandIvory, brandOrange } from '../../../assets/consts/color'

export const DocumentLink = styled.a`
  text-decoration: none;
  display: flex;
  margin: 0 0 32px 0;

  &:hover {
    h4 {
      color: ${brandOrange};
    }
  }
`

export const DocumentLinkIconWrapper = styled.div`
  height: 40px;
  width: 40px;
  margin: 0 16px 0 0;
  flex-shrink: 0;
  flex-grow: 0;
`

export const DocumentLinkTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  word-break: break-all;

  h5 {
    margin: 0 0 4px 0;
  }

  h4 {
    margin: 0;
  }

  ul {
    list-style: none;
  }
`

export const WhatsInTheBoxWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  ${({ isImage }) =>
    isImage &&
    css`
      & > .row {
        width: 100%;
        margin: 0;

        & > div {
          padding: 0;
        }
      }
    `}
`

export const WhatsInTheBoxText = styled.div`
  background: ${brandIvory};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px 40px 60px 40px;
  flex: 1;
  position: relative;

  &:before {
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    content: '';
    height: 60px;
    left: 0;
    position: absolute;
    bottom: 0;
    transform: rotate(90deg);
    width: 60px;
    z-index: 1;
  }
`

export const WhatsInTheBoxImage = styled.div`
  flex: 3;
  padding: 0 40px;

  position: sticky;
  top: 120px;
`

export const StickyWrapper = styled.div`
  position: sticky;
  top: 120px;
`
